import ApprovalsTable from "@features/administration/approvals/ApprovalsTable"
import { Grid } from "@mui/material"

const PublishApprovals = () => {
  return (
    <Grid container>
      <Grid item xs>
        <ApprovalsTable />
      </Grid>
    </Grid>
  )
}

export default PublishApprovals
